export const tramposData = [
  {
    what: "Simulação mostra quais crianças são adotadas (e quais não são) no Brasil",
    where: "Estadão",
    link: "https://arte.estadao.com.br/brasil/adocao/criancas/",
    when: "2019",
    awards: "yes",
    hashtags: "#concepção #texto #análise #visualização"
  },
  {
    what: "Alagamentos nos quatro primeiros meses de 2019 sobem 65% em São Paulo",
    where: "Estadão",
    link: "https://arte.estadao.com.br/sao-paulo/10-anos-de-chuvas/",
    when: "2020",
    awards: "yes",
    hashtags: "#pauta #texto #desenvolvimento #dados"
  },
  {
    what: "Ritmo de festa: o segredo do hit de carnaval",
    where: "Estadão",
    link: "https://arte.estadao.com.br/cultura/carnaval/hits-carnaval-2020/",
    when: "2020",
    awards: "",
    hashtags: "#texto"
  },
  {
    what: "O que preciso saber antes de alugar um imóvel?",
    where: "Estadão",
    link: "https://arte.estadao.com.br/economia/aluguel/quiz-aluguel/",
    when: "2019",
    awards: "",
    hashtags: "#pauta #texto #animações #desenvolvimento"
  },
  {
    what: "Dedo Duro - Espionagem em tempos de ditadura militar",
    where: "TCC",
    link: "https://drive.google.com/file/d/11SF7QyUYL6WxeXs8uiH5rwmezzko07f6/view?usp=sharing",
    when: "2017",
    awards: "",
    hashtags: "#hq #jornalismo #roteiro #apuracao #revisão"
  },
  {
    what: "Layout desenvolvido para futuro site da org Tempo",
    where: "Tempo",
    link: "https://www.figma.com/file/bVCSZg0AmIqINiue0hFHC8/orgtempo?node-id=5%3A152&t=BqrMgdJO6B31MKop-1",
    when: "2022",
    awards: "",
    hashtags: "#figma #layout"
  },
  {
    what: "Layout desenvolvido para projeto do curso da TERA",
    where: "Projeto pessoal",
    link: "https://www.figma.com/design/yOP27ebgFgsjpLZEs6QM11/Untitled?node-id=0-1&t=maM56TEK8J095lSq-1",
    when: "2022",
    awards: "",
    hashtags: "#figma #layout"
  },
  {
    what: "Os 100 artistas de maior sucesso do funk brasileiro na última década",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/cultura,os-100-artistas-de-maior-sucesso-do-funk-brasileiro-na-ultima-decada,1069703",
    when: "2020",
    awards: "",
    hashtags: "#texto #layout"
  },
  {
    what: "Evite o desperdício: descubra como prolongar a validade dos alimentos em casa",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/saude,evite-o-desperdicio-descubra-como-prolongar-a-validade-dos-alimentos-em-casa,1089709",
    when: "2020",
    awards: "",
    hashtags: "#pauta #texto #desenvolvimento",
  },
  {
    what: "Encontre coworkings em São Paulo - PME",
    where: "Estadão",
    link: "https://arte.estadao.com.br/pme/coworkings/",
    when: "2019",
    awards: "",
    hashtags: "#layout #desenvolvimento",
  },
  {
    what: "Brasil supera 1 milhão de casos de COVID-19",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/saude,brasil-supera-1-milhao-de-casos-de-covid-19,1101828",
    when: "2020",
    awards: "",
    hashtags: "#desenvolvimento #layout",
  },
  {
    what: "Qual o destino de R$ 1,2 bilhão de emendas de vereadores de São Paulo nos últimos 10 anos",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/politica,qual-o-destino-de-r-1-2-bilhao-de-emendas-de-vereadores-de-sao-paulo-nos-ultimos-10-anos,1115949",
    when: "2020",
    awards: "",
    hashtags: "#desenvolvimento #layout"
  },
  {
    what: "Mapas de apuração - Covas e Boulos disputam segundo turno; veja como cada bairro votou",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/politica,apuracao-mapas-prefeitura-sp-eleicoes-2020,1135463",
    when: "2020",
    awards: "",
    hashtags: "#desenvolvimento #texto #análise"
  },
  {
    what: "Veja o perfil dos partidos para 2021 na Câmara Municipal",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/politica,psdb-sofre-leve-queda-pt-se-estabiliza-e-psol-avanca-na-camara-municipal-veja-o-perfil-dos-partidos-para-2021,1135749",
    when: "2020",
    awards: "",
    hashtags: "#desenvolvimento #texto #análise"
  },
  {
    what: "Quiz: qual o perfil do colega de trabalho perfeito?",
    where: "Estadão",
    link: "https://www.estadao.com.br/infograficos/economia,quiz-qual-seu-colega-de-trabalho-perfeito,1130965",
    when: "2020",
    awards: "",
    hashtags: "#desenvolvimento #layout"
  },
];
